// extracted by mini-css-extract-plugin
export default {"collapse":"EditCandidateInterviewPage_collapse__5uarw"};